import { Modal, ModalBody, ModalFooter, ModalHeader } from '@lmig/lmds-react-modal';
import { PillButton } from '@lmig/lmds-react-pill-button';
import { Table, TableBody, TableCell, TableHeader, TableRow } from '@lmig/lmds-react-table';
import { Heading } from '@lmig/lmds-react-typography';
import { Link } from '@lmig/lmds-react-link';
import { getBillingURLByAccount } from 'Utilities/URLHelper';
import { useUserData } from 'Foundation/User/UserContext';
import { CircularProgressSpinner } from '@lmig/sales-ui-circular-progress-spinner';
import { useEffect, useState } from 'react';
import './BillingAccountSelect.scss';

export type IBillingAccount = {
  accountNumber: string;
  insuredName: string;
  address: string;
};

type IBillingAccountSelect = {
  isOpen?: boolean;
  onClose: () => void;
  accounts: IBillingAccount[];
};

const BillingAccountSelect = (props: IBillingAccountSelect) => {
  const { userData } = useUserData();
  const [isOpen, setIsOpen] = useState<boolean | undefined>(props.isOpen);
  const [sending, setSending] = useState<string>();

  async function redirectToBilling(account: string) {
    if (userData) {
      setSending(account);
      let url = await getBillingURLByAccount(userData, account);
      if (url) global.open(url, '_blank')?.focus();
      setSending(undefined);
    }
  }

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  return (
    <Modal
      size="medium"
      isOpen={isOpen}
      className="billing-account-select-modal"
      onClose={() => {
        setIsOpen(false);
        props.onClose();
      }}
    >
      <ModalHeader>
        <Heading type="h3-light">Select billing account</Heading>
      </ModalHeader>
      <ModalBody>
        <Table rowStyle="zebra">
          <TableHeader>
            <TableRow>
              <TableCell type="colHead">Account Number</TableCell>
              <TableCell type="colHead">Insured</TableCell>
              <TableCell type="colHead">Address</TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {props.accounts &&
              props.accounts.map((account: IBillingAccount) => (
                <TableRow>
                  <TableCell>
                    {sending && sending == account.accountNumber ? (
                      <CircularProgressSpinner size="16" aria-label="Loading billing application..." />
                    ) : (
                      <Link onClick={() => redirectToBilling(account.accountNumber)}>{account.accountNumber}</Link>
                    )}
                  </TableCell>
                  <TableCell>{account.insuredName}</TableCell>
                  <TableCell>{account.address}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <PillButton
          variant="secondary"
          dynamicWidth={true}
          onClick={() => {
            setIsOpen(false);
            props.onClose();
          }}
        >
          Close
        </PillButton>
      </ModalFooter>
    </Modal>
  );
};

export default BillingAccountSelect;
